import HTTPServices from "../HTTPServices/httpService";

const measurementSettingsServices = {
  //(1)
  // searchByProductItemAndSettingsID: async function (
  //   productItemGUID: string,
  //   measurementSettingsGUID: string
  // ) {
  //   let dataObj = JSON.stringify({
  //     productItemGUID: productItemGUID,
  //     measurementSettingsGUID: measurementSettingsGUID,
  //   });

  //   console.log(
  //     "'searchByProductItemAndSettingsID' service called: postdata: " + dataObj
  //   );
  //   let result = await HTTPServices.post(
  //     "measurementSettings/getMeasurementSettingAndDetailByProductItemAndSettingDetailID",
  //     dataObj
  //   );
  //   console.log('retrun result --->'+ result);
  //   return result;
  // },

  //(**) Get all Measurement settings
  getAll: async function () {
    console.log("'Get all measurement settings' service called: '");
    let result = await HTTPServices.get("measurementSettings/getAll");
    console.log("retrun result --->" + result);
    return result;
  },
  //(**) Get all Measurement settings With Product Item Name
  getAllWithProductItemName: async function () {
    console.log("'Get getAllWithProductItemName' service called: '");
    let result = await HTTPServices.get(
      "measurementSettings/getAllWithProductItemName"
    );
    console.log("retrun result --->" + JSON.stringify(result[0]));
    return result;
  },

  //(2)
  save: function (customerObj) {
    // console.log("'customerServices' service called: save : " + customerObj);
    return HTTPServices.post("customer/save", customerObj);
  },
  searchByCustomerGUID: async function (customerGUID) {
    console.log(
      "'customerServices' service called: searchByCustomerGUID: " + customerGUID
    );
    let customerGot = await HTTPServices.get(
      "customer/getByID/" + customerGUID
    );
    console.log("result got: " + customerGot.name);
    return customerGot;
  },
};

export default measurementSettingsServices;
